import { render, staticRenderFns } from "./CaddieFeePriceRegistration.vue?vue&type=template&id=96a07da2&scoped=true&"
import script from "./CaddieFeePriceRegistration.vue?vue&type=script&lang=js&"
export * from "./CaddieFeePriceRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CaddieFeePriceRegistration.vue?vue&type=style&index=0&id=96a07da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a07da2",
  null
  
)

export default component.exports